import type { BadgeProps } from '@wartek-id/badge'
import { Badge } from '@wartek-id/badge'

import type { PengawasSchool } from 'types/kinerja-ks-pelaksanaan'
import type { FC } from 'react'

interface BadgePerilakuKerjaProps {
  status: PengawasSchool['perilakuKerjaStatus']
  colorFinished?: BadgeProps['variant']
  colorNotFinished?: BadgeProps['variant']
}

const BadgePerilakuKerja: FC<BadgePerilakuKerjaProps> = ({
  status = null,
  colorFinished = 'success', // default color for finished status
  colorNotFinished = 'critical', // default color for not finished status
}) => {
  if (!status) return <>-</>

  return (
    <Badge
      variant={
        status?.toLowerCase() == 'sudah dinilai'
          ? colorFinished
          : colorNotFinished
      }
    >
      {status}
    </Badge>
  )
}
export default BadgePerilakuKerja
